#import "./SentenceDetails.graphql"
#import "./TorahMelodyDetails.graphql"
#import "./HaftarahMelodyDetails.graphql"
#import "./SentenceGroupMelodyDetails.graphql"
#import "./PronunciationDetails.graphql"
#import "./TagDetails.graphql"
#import "./SegmentedSentenceDetails.graphql"
fragment sentenceRecordingDetails on SentenceRecordingType {
  id
  created
  modified
  file
  uploadedAt
  processingStartedAt
  processingEndedAt
  processingSuccess
  processingMessage
  splitDbfsPlus
  torahMelody {
    ...torahMelodyDetails
  }
  haftarahMelody {
    ...haftarahMelodyDetails
  }
  sentenceGroupMelody {
    ...sentenceGroupMelodyDetails
  }
  pronunciation {
    ...pronunciationDetails
  }
  tags {
    ...tagDetails
  }
  segments {
    id
    order
  }
  sentence {
    ...sentenceDetails
  }
  segmentedSentence {
    ...segmentedSentenceDetails
  }
}
